import { useMemo } from "react";

const COLORS = ["#E07A5F", "#3A5A40", "#E9C46A", "#F4A261", "#8AB17D", "#FFFFFF"];

export default function Confetti({ pieces = 40 }) {
    const items = useMemo(() => {
        return Array.from({ length: pieces }, (_, i) => {
            const left = Math.random() * 100;
            const dx = (Math.random() - 0.5) * 200; // horizontal drift px
            const dur = 3 + Math.random() * 3;
            const delay = Math.random() * 0.6;
            const color = COLORS[i % COLORS.length];
            const size = 6 + Math.random() * 8;
            const shape = Math.random() > 0.5 ? "2px" : "999px";
            return { id: i, left, dx, dur, delay, color, size, shape };
        });
    }, [pieces]);

    return (
        <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden" data-testid="confetti">
            {items.map((it) => (
                <span
                    key={it.id}
                    className="confetti-piece"
                    style={{
                        left: `${it.left}%`,
                        width: `${it.size}px`,
                        height: `${it.size * 1.4}px`,
                        background: it.color,
                        borderRadius: it.shape,
                        animationDuration: `${it.dur}s`,
                        animationDelay: `${it.delay}s`,
                        // @ts-ignore CSS var
                        "--dx": `${it.dx}px`,
                        "--dur": `${it.dur}s`,
                    }}
                />
            ))}
        </div>
    );
}
